import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SectionDiv } from "..";
export default function DataTable({ data = {} }) {
    const { rows = [], header = [] } = data;
    return /*#__PURE__*/ _jsx(SectionDiv, {
        children: /*#__PURE__*/ _jsxs("table", {
            style: styles.table,
            children: [
                header.length > 0 && /*#__PURE__*/ _jsx("thead", {
                    children: /*#__PURE__*/ _jsx("tr", {
                        children: header.map((column)=>/*#__PURE__*/ _jsx("th", {
                                style: styles.header,
                                children: column
                            }, column))
                    })
                }),
                /*#__PURE__*/ _jsx("tbody", {
                    children: rows.map((row, index)=>/*#__PURE__*/ _jsx("tr", {
                            children: Object.keys(row).map((key)=>/*#__PURE__*/ _jsx("td", {
                                    style: styles.body,
                                    children: row[key]
                                }, key))
                        }, index))
                })
            ]
        })
    });
}
const styles = {
    table: {
        paddingTop: 10,
        fontSize: "0.875rem"
    },
    header: {
        padding: "5px",
        textAlign: "left"
    },
    body: {
        padding: "8px 5px",
        fontWeight: "normal",
        textAlign: "left",
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
    }
};
